import { render, staticRenderFns } from "./changeBefore.vue?vue&type=template&id=32ac3c60&scoped=true&"
import script from "./changeBefore.vue?vue&type=script&lang=js&"
export * from "./changeBefore.vue?vue&type=script&lang=js&"
import style0 from "./changeBefore.vue?vue&type=style&index=0&id=32ac3c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ac3c60",
  null
  
)

component.options.__file = "changeBefore.vue"
export default component.exports